module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product-table"
  }, [_c('h2', {
    staticClass: "product-table-title"
  }, [_vm._v(_vm._s(_vm.table.title || "Produktauswahl"))]), _vm._v(" "), _c('table', {
    staticClass: "table is-striped is-narrow"
  }, [_c('thead', [_c('tr', _vm._l((_vm.table.config), function(column, key) {
    return (!column.disabled) ? _c('th', {
      key: key,
      domProps: {
        "innerHTML": _vm._s(column.label)
      }
    }) : _vm._e()
  }), 0)]), _vm._v(" "), _c('tbody', [_vm._l((_vm.table.data), function(product, productIndex) {
    return _vm._l((_vm._.get(product, _vm.table.multiRowPath, 1)), function(multiRowIndex) {
      return _c('tr', {
        key: productIndex + '-' + multiRowIndex,
        class: multiRowIndex === 1 ? 'parentRow' : 'childRow'
      }, _vm._l((_vm.table.config), function(column, columnIndex) {
        return _c('tablefield', {
          key: productIndex + '-' + multiRowIndex + '-' + columnIndex,
          attrs: {
            "column": column,
            "product": product,
            "secondary-index": multiRowIndex - 1,
            "totalWeight": _vm.totalWeight,
            "useLegacyFormatting": _vm.table.useLegacyFormatting
          }
        })
      }), 1)
    })
  })], 2)]), _vm._v(" "), (_vm.showTime) ? _c('div', {
    staticClass: "fineprint table-time"
  }, [_vm._v(_vm._s(_vm.time))]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1dff9136"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/table/TableOnepagerProducts.vue
// module id = 663
// module chunks = 0